import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroCarousel() {
    const navigate = useNavigate();

    return (
        <section className="hero">
            <div className="container">
                <div id="quoteCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#quoteCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#quoteCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#quoteCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>

                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="quote-box mx-auto">
                                <p className="quote-text">ಸತ್ಯ ಸುನಾದದ ಚಿಲಕವ ಸರಿಸಿ, <br className="d-md-none" /> ರಾಗ ತಾಳಗಳ ಕೋಟೆಯ ಭೇದಿಸಿ ||</p>
                                <p className="quote-text">ಕೃತಿ ಕೀರ್ತನದ ಅಂಗಳ ತೋರಿಸಿ, <br className="d-md-none" /> ಗೇಯಗಾನ ಗರ್ಭಗುಡಿಯಲ್ಲಿರುವ ||</p>
                                <p className="quote-text">ಅಗೋಚರ ನಿರಾಕಾರ ನಾದಬ್ರಹ್ಮನ, <br className="d-md-none" /> ಅನುಭವಕೆತಾರೋ ಪದ್ಮನಾಭ ದಾಸಗೆ ||</p>
                            </div>
                        </div>

                        <div className="carousel-item">
                            <div className="quote-box mx-auto">
                                <p className="quote-text">Existing inside thee, a primordial soul,<br className="d-md-none" /> is an unseen Creator.</p>
                                <p className="quote-text">A structure & shapeless Preserver,<br className="d-md-none" /> Your Ultimate Self.</p>
                                <p className="quote-text">A Beautiful Castle,<br className="d-md-none" /> formed by rhythm & raaga awaits discovery.</p>
                            </div>
                        </div>

                        <div className="carousel-item">
                            <div className="quote-box mx-auto">
                                <p className="quote-text    ">तुम्हारे अंदर एक आदिम आत्मा के रूप में, <br className="d-md-none" /> एक अनदेखा रचयिता मौजूद है।</p>
                                <p className="quote-text">एक संरचना और आकारहीन पालक, <br className="d-md-none" /> तुम्हारा परम स्वरूप।</p>
                                <p className="quote-text">ताल और राग से बना एक सुंदर महल, <br className="d-md-none" /> खोजे जाने का इंतज़ार कर रहा है।</p>
                            </div>
                        </div>
                    </div>

                    <button className="carousel-control-prev" type="button" data-bs-target="#quoteCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#quoteCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            <div className="discover-button-container d-flex justify-content-center mt-5 position-relative" style={{ height: '80px', cursor: 'pointer' }} onClick={() => navigate('/contact')}>
                <button id="discovernow">Discover Now</button>
                <div id="label">Discover Now</div>
            </div>
        </section>
    );
}